import config from '@/config';
import { createHttpClient } from '@/http';

/**
 * Currency converter
 */
class OpenExchangeRates {
  constructor(appId, httpClient) {
    this.appId = appId;
    this.httpClient = httpClient;
  }

  /**
   * Convert currency
   *
   * @return {Promise}
   */
  convert(data = {}) {
    const { to, from, value } = data;

    return this.httpClient.get(
      `https://openexchangerates.org/api/convert/${value}/${from}/${to}?app_id=${this.appId}`);
  }

  latest(baseCurrency) {
    return this.httpClient.get(
      `https://openexchangerates.org/api/latest.json?app_id=${this.appId}&base=${baseCurrency}`
    );
  }

  currencies() {
    return this.httpClient.get(
      `https://openexchangerates.org/api/currencies.json?app_id=${this.appId}`
    );
  }

  historical(date, baseCurrency, resultingCurrencies) {
    return this.httpClient.get(
      `https://openexchangerates.org/api/historical/${date}.json?app_id=${this.appId}&base=${baseCurrency}&symbols=${resultingCurrencies}`
    );
  }

  async convertFromLatest({ from, to, value }) {
    try {
      const { data } = await this.latest(from);
      return data.rates[to] * value;
    } catch (e) {
      throw new Error('Could not convert currency');
    }
  }
}

export default new OpenExchangeRates(config.currencyAppId, createHttpClient());
